/**
 * Node props that change on every frame of a move but that no card reads: React Flow places the card with its
 * own wrapper's transform, so a card re-render for these would only redraw the same content.
 */
const IGNORED = new Set(['positionAbsoluteX', 'positionAbsoluteY', 'zIndex', 'dragging']);

/**
 * `React.memo` comparator for the cards: the same props apart from `IGNORED`. `data` compares by identity, so
 * GraphCanvas keeps each node's data object while its fields are unchanged (see `createNodeDataCache`).
 */
export function sameCardProps(prev: object, next: object): boolean {
  const a = prev as Record<string, unknown>;
  const b = next as Record<string, unknown>;
  const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
  for (const key of keys) {
    if (!IGNORED.has(key) && !Object.is(a[key], b[key])) return false;
  }
  return true;
}
